import { createAction } from 'typesafe-actions'
import { type CancelReason } from '@/connect-types/members/cancel.types'

/**
 * DELETE
 *
 * Path: /members/{uid}/notifications
 */

// FIXME: add in request and query params

export const sendSupportEmailRequest = createAction(
  'SEND_SUPPORT_EMAIL_REQUEST',
  (resolve: any) => (request: CancelReason) => resolve({ request })
)

export const sendSupportEmailRequestSuccess = createAction(
  'SEND_SUPPORT_EMAIL_REQUEST_SUCCESS',
  (resolve: any) => (response: any) => resolve({ response })
)

export const sendSupportEmailRequestFailure = createAction(
  'SEND_SUPPORT_EMAIL_REQUEST_FAILURE',
  (resolve: any) => () => resolve()
)
